export default [
    {
        path: '/kpi',
        component: () => import('@/views/kpi/kpi'),
    },
    {
        path: '/kpiRecord',
        component: () => import('@/views/kpiRecord/kpiRecord'),
    },
    {
        path: '/kpiResult',
        component: () => import('@/views/kpiResult/kpiResult'),
    },
]